import Marquee from "react-fast-marquee";

const WORDS = ["Ceramic Coating", "Paint Correction", "Interior Detail", "Exterior Detail", "Cars", "Bikes", "Boats"];

export default function EditorialMarquee() {
  return (
    <div data-testid="marquee" className="py-8 md:py-12 border-y border-zinc-800 bg-[#030303] overflow-hidden">
      <Marquee speed={40} gradient={false}>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-display font-bold uppercase text-5xl md:text-8xl text-stroke tracking-tight">{w}</span>
            <span className="w-3 h-3 bg-[#FF3B30] rotate-45" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
